import React, { useState, useEffect } from "react";

const ProductCard = ({
  title,
  images,
  price,
  description = "",
  features = [],
  bookingLink = "https://wa.me/9371939191",
}) => {
  const galleryImages = Array.isArray(images) && images.length ? images : [];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (!isHovered && galleryImages.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
      }, 2200);
      return () => clearInterval(interval);
    }
  }, [isHovered, galleryImages.length]);

  if (!galleryImages.length) {
    return null;
  }

  return (
    <div
      className="w-full max-w-sm overflow-hidden rounded-2xl border border-amber-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="group relative">
        <div className="relative h-48 overflow-hidden sm:h-56 md:h-60">
          <img
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            src={galleryImages[currentIndex]}
            alt={`${title} ${currentIndex + 1}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-black/10 to-transparent" />
          <div className="absolute left-3 top-3 rounded-full bg-amber-100/95 px-3 py-1 text-xs font-bold uppercase tracking-wide text-emerald-950 shadow-sm">
            Stay
          </div>
          {galleryImages.length > 1 && (
            <div className="absolute right-3 top-3 rounded-full bg-black/40 px-2 py-1 text-[10px] font-semibold text-white backdrop-blur-sm">
              {currentIndex + 1}/{galleryImages.length}
            </div>
          )}

          {galleryImages.length > 1 && (
            <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full bg-black/35 px-2 py-1 backdrop-blur-sm">
              {galleryImages.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  aria-label={`Show image ${index + 1}`}
                  onClick={() => setCurrentIndex(index)}
                  className={`h-2.5 w-2.5 rounded-full transition ${
                    index === currentIndex ? "bg-white" : "bg-white/50"
                  }`}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="p-4 sm:p-5">
        <div className="mb-2 flex items-center justify-between gap-2">
          <h5 className="text-lg font-semibold text-gray-900 sm:text-xl">
            {title}
          </h5>
          <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-bold uppercase tracking-wide text-amber-900">
            Popular
          </span>
        </div>

        {description && (
          <p className="mb-3 text-sm text-gray-600 sm:text-base">
            {description}
          </p>
        )}

        <div className="mb-3 flex items-center justify-between">
          <div>
            <span className="text-xl font-bold text-stone-900 sm:text-2xl">
              {price}/-
            </span>
            <span className="block text-sm text-gray-600">Per Person</span>
          </div>
        </div>

        {features.length > 0 && (
          <ul className="mb-4 space-y-1 text-sm text-gray-700">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className="mt-1 text-emerald-700">✓</span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        )}

        <a
          href={bookingLink}
          target="_blank"
          rel="noreferrer"
          className="inline-flex w-full items-center justify-center rounded-full bg-emerald-800 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-900"
        >
          Book This Stay
        </a>
      </div>
    </div>
  );
};

export default ProductCard;
